import React from 'react';
import PropTypes from 'prop-types';
import { Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import Slider from 'react-rangeslider';

class SummaryItem extends React.Component {
  render() {
    const potentialValue = this.props.potentialValue;
    let valuePrefix = '',
        valueSuffix = '';
    switch(this.props.valueType.toLowerCase()) {
      case 'money':
        valuePrefix = '$';
        break;
      case 'percent':
        valueSuffix = '%';
        break;
    }
    const layout = {
      currentValue: `${valuePrefix}${this.props.value.toLocaleString()}${valueSuffix}`,
      potentialValue: `${valuePrefix}${potentialValue.toLocaleString()}${valueSuffix}`,
      sliderValue: `${this.props.sliderValue}%`
    };
    
    return (
      <FormGroup className="equal">
        <Col xs={12} sm={3} md={2}>
          <ControlLabel>{this.props.title}</ControlLabel>
        </Col>

        <Col xs={3} sm={2}>
          <FormControl.Static>{layout.currentValue}</FormControl.Static>
        </Col>

        <Col xs={6} sm={4} md={5}>
          {this.props.showSlider &&
          <div className="slider">
            <Slider
                value={this.props.sliderValue}
                handleLabel={layout.sliderValue}
                tooltip={false}
                onChange={this.props.onSliderValueChange}
            />
            {/* <div className="value">{`${this.props.sliderValue}%`}</div> */}
          </div>}          
        </Col>
        
        <Col xs={3} sm={2} className="potential-column">
          <FormControl.Static>{layout.potentialValue}</FormControl.Static>
        </Col>
      </FormGroup>
    );
  }
}

SummaryItem.defaultProps = {
  initialSliderValue: 50,
  showSlider: true,
  valueType: "number"
};

SummaryItem.propTypes = {
  initialSliderValue: PropTypes.number,
  onSliderValueChange: PropTypes.func,
  onValueChange: PropTypes.func,
  potentialValue: PropTypes.number.isRequired,
  showSlider: PropTypes.bool,
  sliderValue: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.number.isRequired,
  valueType: PropTypes.string
};

export default SummaryItem;


// WEBPACK FOOTER //
// ./src/Components/roi-calculator/SummaryItem.jsx